import { Link } from '@tanstack/react-router';
import { ChevronRight, type LucideIcon, Megaphone, Settings, UserRound, Users } from 'lucide-react';
import { Button } from '../components/ui/Button.tsx';
import { Card, PageHeader } from '../components/ui/Layout.tsx';
import { ThemeToggle } from '../components/ui/ThemeToggle.tsx';
import { useAuth } from '../lib/auth.tsx';

type MoreTo = '/account' | '/campaigns' | '/settings/workspace' | '/settings/members';

/** The phone "More" tab: account, admin settings, appearance and sign out. */
export function MorePage() {
  const { claims, signOut } = useAuth();
  if (!claims) return null;
  const links: { to: MoreTo; label: string; Icon: LucideIcon }[] = [
    { to: '/account', label: 'Account', Icon: UserRound },
  ];
  if (claims.workspaceId && claims.role === 'admin') {
    links.push({ to: '/campaigns', label: 'Campaigns', Icon: Megaphone });
    links.push({ to: '/settings/workspace', label: 'Settings', Icon: Settings });
    links.push({ to: '/settings/members', label: 'Members', Icon: Users });
  }
  return (
    <div className="flex flex-col gap-6">
      <PageHeader title="More" />
      <nav
        aria-label="More"
        className="overflow-hidden rounded-lg bg-surface-raised ring-1 ring-hairline"
      >
        <ul className="divide-y divide-hairline">
          {links.map(({ to, label, Icon }) => (
            <li key={to}>
              <Link
                to={to}
                className="body flex min-h-12 items-center gap-3 px-4 text-ink focus-visible:outline-2 focus-visible:outline-focus-ring"
              >
                <Icon size={20} strokeWidth={1.75} className="text-ink-muted" aria-hidden />
                <span className="flex-1">{label}</span>
                <ChevronRight size={20} strokeWidth={1.75} className="text-ink-muted" aria-hidden />
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Card title="Appearance">
        <ThemeToggle />
      </Card>
      <div>
        <Button variant="secondary" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
